/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const chevronUp = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M12 8l-6 5.4 1 1.2 5-4.6 5 4.6 1-1.2z" />
	</SVG>
);

export default chevronUp;
